import { Injectable } from '@angular/core';
import * as _ from 'lodash';

import { Subject as su } from 'src/app/_models/academic/subject.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Subject } from 'src/app/_models/academic/subject.interface';

@Injectable({
  providedIn: 'root'
})
export class SubjectService {
  selectedSubjectId: number = 0;

  url = `${environment.apiUrl}`;

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get(`${this.url}/Subjects/GetAll`);
  }

  addSubject(subject: su) {
    return this.http.post(`${this.url}Subjects/Add`, subject);
  }

  deleteSubject(subjectId: number) {
    return this.http.delete(`${this.url}/Subjects/Delete/${subjectId}`);
  }
  update(subject: su) {
    return this.http.put(`${this.url}/Subjects/Update`, subject);
  }

  getChildsSubjects(globalSubjectId: number | null, sectionId: number | null = null) {
    // TODO: Check query string behaviour

    let url = `${this.url}Subjects/GetChildSubjects/?globalSubjectId=${globalSubjectId}`;
    if (sectionId)
      url = `${url}&sectionId=${sectionId}`;

    if (globalSubjectId) return this.http.get(url);

    return this.http.get(`${this.url}Subjects/GetChildSubjects`);
  }
  getSchoolSubjectsByGlobalSubjectId(globalSubjectId)
  {
    return this.http.get(`${this.url}Subjects/GetSchoolSubjectsByGlobalSubjectId?globalSubjectId=${globalSubjectId}`);
  }

  GetChildSubjectsByName(name)
  {
    return this.http.get(`${this.url}Subjects/GetChildSubjectsByName/${name}`);
  }

  getChildsSubjectsForAllClassSections(globalSubjectId?: number, sectionIds?: number[], globalClassId = null) {
    let url = ""
    if(globalSubjectId)
    url=`${this.url}Subjects/getSubjectsForAllClassSections?globalSubjectId=${globalSubjectId}`;
    else
    url=`${this.url}Subjects/getSubjectsForAllClassSections?`

    if (sectionIds && sectionIds.length > 0) {
      for (let id of sectionIds)
        url += `&sectionIds=${id}`;
    }

    if(globalClassId)
    {
      url += `&globalClassId=${globalClassId}`;
    }
    return this.http.get(`${url}`);
  }

  getChildSubjectsGropedByParent() {
    return this.http.get(`${this.url}Subjects/GetChildSubjectsGropedByParent`);
  }

  getAllStudentsSection(sectionSubjectId: number) {
    return this.http.get(`${this.url}SectionSubjects/GetSubjectStudents/${sectionSubjectId}`);
  }

  GetSectionSubjectsAsmtCategoryDetails(sectionSubjectId:number)
  {
    return this.http.get(`${this.url}SectionSubjects/GetSectionSubjectsAsmtCategoryDetails/${sectionSubjectId}`); 
  }

  UpdateStudentSectionSubject(sectionSubjectId: number, studentsIds: string[]) {
    return this.http.put(`${this.url}SectionSubjects/UpdateStudentSectionSubject/${sectionSubjectId}`, studentsIds);
  }

  getById(subjectId: number): Observable<Subject> {
    return this.http.get<Subject>(`${this.url}/Subjects/GetById/${subjectId}`);
  }

  getAllGlobalSubjects()
  {
    return this.http.get(`${this.url}Subjects/GetAllGlobalSubjects`)
  }
  getSchoolGlobalSubjects(schoolId:number, educationalProgramId:number)
  {
    return this.http.get(`${this.url}Subjects/GetSchoolGlobalSubjects?schoolId=${schoolId}&educationalProgramId=${educationalProgramId}`);
  }
  addOrUpdateGlobalSchoolSubject(schoolGlobalSubjects:any)
  {
    return this.http.post(`${this.url}Subjects/AddOrUpdateSchoolGlobalSubjects`, schoolGlobalSubjects);
  }

  getGlobalSubjectsBySchoolAndProgram()
  {
    return this.http.get(`${this.url}Subjects/GetGlobalSubjectsBySchoolAndProgram`);
  }

  UpdateSchoolGlobalSubjectOrder(data)
  {
    return this.http.put(`${this.url}Subjects/UpdateSchoolGlobalSubjectOrder`,data);
  }
}
